import React, { useEffect, useRef, useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { healthApi, notificationApi } from '../api/apiClient';
import { useAuth } from '../context/AuthContext';
import WindBannerLogo from './WindBannerLogo';
import { ArrowLeftIcon, ArrowRightIcon, BellIcon, LogoutIcon } from './AppIcons';
import './Layout.css';

function KnowledgeIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6.5 4.25A2.75 2.75 0 0 0 3.75 7v10A2.75 2.75 0 0 0 6.5 19.75h11A2.75 2.75 0 0 0 20.25 17V7A2.75 2.75 0 0 0 17.5 4.25h-11Zm.5 2h10a.75.75 0 0 1 .75.75v8.63a6.08 6.08 0 0 0-2.75-.63c-1.17 0-2.26.27-3.25.75a7.46 7.46 0 0 0-3.25-.75 6.08 6.08 0 0 0-2.75.63V7a.75.75 0 0 1 .75-.75Zm1.5 3a.75.75 0 0 1 .75-.75h1.5a.75.75 0 1 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm4.75 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 1 1 0 1.5H14a.75.75 0 0 1-.75-.75Z" />
    </svg>
  );
}

function AdminIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2.75 4.75 6v5.1c0 4.42 2.95 8.54 7.25 10.15 4.3-1.61 7.25-5.73 7.25-10.15V6L12 2.75Zm0 2.05 5.75 2.58v3.72c0 3.63-2.33 7.01-5.75 8.47-3.42-1.46-5.75-4.84-5.75-8.47V7.38L12 4.8Zm0 2.7a3 3 0 0 0-3 3v.75h-1a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h8a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75h-1v-.75a3 3 0 0 0-3-3Zm-1.5 3a1.5 1.5 0 0 1 3 0v.75h-3v-.75Z" />
    </svg>
  );
}

function CVIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 3.75A2.75 2.75 0 0 0 4.25 6.5v11A2.75 2.75 0 0 0 7 20.25h10A2.75 2.75 0 0 0 19.75 17.5v-11A2.75 2.75 0 0 0 17 3.75H7Zm0 1.5h10c.69 0 1.25.56 1.25 1.25v11c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25v-11c0-.69.56-1.25 1.25-1.25Zm2 2.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm4.25 1a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM8.25 13a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75h7.5a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-7.5Z" />
    </svg>
  );
}

function DiskIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5.75 4.75h12.5A2.75 2.75 0 0 1 21 7.5v9a2.75 2.75 0 0 1-2.75 2.75H5.75A2.75 2.75 0 0 1 3 16.5v-9a2.75 2.75 0 0 1 2.75-2.75Zm0 1.5c-.69 0-1.25.56-1.25 1.25v9c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25v-9c0-.69-.56-1.25-1.25-1.25H5.75Zm1.5 2.25a.75.75 0 0 1 .75-.75h8a.75.75 0 1 1 0 1.5H8a.75.75 0 0 1-.75-.75Zm0 6.5a.75.75 0 0 1 .75-.75h1.5a.75.75 0 1 1 0 1.5H8a.75.75 0 0 1-.75-.75Zm9.75-.75a.75.75 0 1 1 0 1.5H13a.75.75 0 0 1 0-1.5h4.25Z" />
    </svg>
  );
}

function AgendaIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8.75 4.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v1h2.5v-1a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v1h1.25A2.75 2.75 0 0 1 21 8.5v10A2.75 2.75 0 0 1 18.25 21.25h-12.5A2.75 2.75 0 0 1 3 18.5v-10a2.75 2.75 0 0 1 2.75-2.75h1.25v-1a.75.75 0 0 1 .75-.75Zm9.75 7.75a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" />
    </svg>
  );
}

function SupportIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2.75 4.75 6v5.1c0 4.42 2.95 8.54 7.25 10.15 4.3-1.61 7.25-5.73 7.25-10.15V6L12 2.75Zm0 2.05 5.75 2.58v3.72c0 3.63-2.33 7.01-5.75 8.47-3.42-1.46-5.75-4.84-5.75-8.47V7.38L12 4.8Zm0 2.7a3 3 0 0 0-3 3v.75h-1a.75.75 0 0 0-.75.75v3.5c0 .41.34.75.75.75h8a.75.75 0 0 0 .75-.75v-3.5a.75.75 0 0 0-.75-.75h-1v-.75a3 3 0 0 0-3-3Zm-1.5 3a1.5 1.5 0 0 1 3 0v.75h-3v-.75Z" />
    </svg>
  );
}

function formatDeployTime(iso) {
  if (!iso || iso === 'unknown') return '—';
  try {
    return new Date(iso).toLocaleString('nl-NL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: 'Europe/Amsterdam',
      timeZoneName: 'short',
    });
  } catch {
    return iso;
  }
}

function formatBytes(bytes) {
  const value = Number(bytes);
  if (!Number.isFinite(value) || value < 0) return '—';
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let size = value;
  let unitIdx = 0;
  while (size >= 1024 && unitIdx < units.length - 1) {
    size /= 1024;
    unitIdx += 1;
  }
  const decimals = unitIdx === 0 ? 0 : size >= 100 ? 0 : size >= 10 ? 1 : 2;
  return `${size.toFixed(decimals)} ${units[unitIdx]}`;
}

export default function Layout() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [apiBuild, setApiBuild] = useState(null);
  const [apiUnavailable, setApiUnavailable] = useState(false);
  const [hasNewVersion, setHasNewVersion] = useState(false);
  const latestCommitRef = useRef(null);
  const [notifOpen, setNotifOpen] = useState(false);
  const [notifUnread, setNotifUnread] = useState(0);
  const [notifItems, setNotifItems] = useState([]);

  const loadNotifications = async () => {
    try {
      const [c, list] = await Promise.all([
        notificationApi.unreadCount(),
        notificationApi.list(),
      ]);
      setNotifUnread(Number(c.data?.count) || 0);
      setNotifItems(list.data || []);
    } catch {
      /* not logged in or API error */
    }
  };

  useEffect(() => {
    loadNotifications();
    const n = setInterval(loadNotifications, 60000);
    return () => clearInterval(n);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const loadHealth = async () => {
      try {
        const res = await healthApi.get();
        if (!cancelled && res.data) {
          const nextCommit = res.data.buildCommit || null;
          setApiUnavailable(false);
          setApiBuild({
            commit: nextCommit,
            time: res.data.buildTime,
            diskFreeBytes: res.data.diskFreeBytes,
            diskTotalBytes: res.data.diskTotalBytes,
            activeColor: res.data.activeColor,
            instanceColor: res.data.instanceColor,
            deployAutomation: res.data.deployAutomation ?? null,
          });
          if (latestCommitRef.current && nextCommit && latestCommitRef.current !== nextCommit) {
            setHasNewVersion(true);
          }
          latestCommitRef.current = nextCommit;
        }
      } catch {
        if (!cancelled) {
          setApiUnavailable(true);
        }
      }
    };

    loadHealth();
    const timer = setInterval(() => {
      loadHealth();
    }, 15000);

    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  const uiCommit = process.env.REACT_APP_BUILD_COMMIT;
  const uiTime = process.env.REACT_APP_BUILD_TIME;

  const handleLogout = () => {
    logout();
    // Use window.location to ensure clean redirect after logout
    window.location.href = '/login';
  };

  const handleReloadForUpdate = () => {
    window.location.reload();
  };

  return (
    <div className={`v-layout ${sidebarCollapsed ? 'v-layout--collapsed' : ''}`}>
      {/* ─── Sidebar ─── */}
      <aside className="v-sidebar">
        <div className="v-sidebar__header">
          <div className="v-logo">
            <WindBannerLogo compact={sidebarCollapsed} name="via-ventus" subtitle="Knowledge Base" />
          </div>
          <div className="v-sidebar__header-actions">
            {user && (
              <div className="v-notif-wrap">
                <button
                  type="button"
                  className="v-sidebar__notif-btn"
                  title="Notifications"
                  onClick={() => {
                    setNotifOpen((o) => !o);
                    loadNotifications();
                  }}
                >
                  <span className="v-notif-bell" aria-hidden><BellIcon /></span>
                  {notifUnread > 0 && <span className="v-notif-badge">{notifUnread > 9 ? '9+' : notifUnread}</span>}
                </button>
                {notifOpen && (
                  <div className="v-notif-panel">
                    <div className="v-notif-panel__head">
                      <span>Notifications</span>
                      <button type="button" className="v-notif-panel__mark" onClick={() => { notificationApi.markAllRead().then(loadNotifications); }}>
                        Mark all read
                      </button>
                    </div>
                    <div className="v-notif-panel__list">
                      {notifItems.length === 0 ? (
                        <div className="v-notif-empty">No notifications</div>
                      ) : (
                        notifItems.slice(0, 12).map((n) => (
                          <button
                            key={n.id}
                            type="button"
                            className={`v-notif-item ${n.readAt ? 'is-read' : ''}`}
                            onClick={() => {
                              if (!n.readAt) notificationApi.markRead(n.id).then(loadNotifications);
                              if (n.linkPath) {
                                navigate(n.linkPath);
                                setNotifOpen(false);
                              }
                            }}
                          >
                            <strong>{n.title}</strong>
                            <span>{n.body}</span>
                            <time>{new Date(n.createdAt).toLocaleString()}</time>
                          </button>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
            {user && (
              <button
                type="button"
                className="v-sidebar__mobile-signout"
                onClick={handleLogout}
                title="Uitloggen"
              >
                <span className="v-sidebar__mobile-signout-icon" aria-hidden>
                  <LogoutIcon />
                </span>
                <span className="v-sidebar__mobile-signout-text">Uitloggen</span>
              </button>
            )}
            <button
              className="v-sidebar__toggle"
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              title={sidebarCollapsed ? 'Expand' : 'Collapse'}
            >
              {sidebarCollapsed ? <ArrowRightIcon /> : <ArrowLeftIcon />}
            </button>
          </div>
        </div>

        <nav className="v-sidebar__nav">
          <div className="v-sidebar__section">
            {!sidebarCollapsed && <span className="v-sidebar__label">Dashboard</span>}
            <NavLink to="/workspaces" className="v-sidebar__link" end>
              <span className="v-sidebar__icon"><KnowledgeIcon /></span>
              {!sidebarCollapsed && <span>Documents</span>}
            </NavLink>
            <NavLink to="/my-agenda" className="v-sidebar__link">
              <span className="v-sidebar__icon"><AgendaIcon /></span>
              {!sidebarCollapsed && <span>Dashboard</span>}
            </NavLink>
          </div>

          <div className="v-sidebar__section">
            {!sidebarCollapsed && <span className="v-sidebar__label">Apps</span>}
            {/* ASA-258/ASA-686: bewuste, load-bearing keuze — NIET reverten.
                Label 'Ventus Slimme Assistent' + de absolute origin-link (geen /cv-app/-
                redirect) herstellen de kernnavigatie naar het product. Een brede revert
                (e56c8ec) haalde ze per ongeluk weg en bracht de Highest-bug ASA-258
                (self-reference: link verwees naar het portaal zelf) terug. */}
            <a href={`${window.location.origin}/slimme-assistent/`} target="_blank" rel="noopener noreferrer" className="v-sidebar__link">
              <span className="v-sidebar__icon"><CVIcon /></span>
              {!sidebarCollapsed && <span>Ventus Slimme Assistent</span>}
            </a>
          </div>

          <div className="v-sidebar__section">
            {!sidebarCollapsed && <span className="v-sidebar__label">AI Governance</span>}
            <NavLink to="/support/security" className="v-sidebar__link v-sidebar__link--support">
              <span className="v-sidebar__icon v-sidebar__icon--support"><SupportIcon /></span>
              {!sidebarCollapsed && <span>Security & Compliance</span>}
            </NavLink>
            <NavLink to="/support/teams-bot" className="v-sidebar__link v-sidebar__link--support">
              <span className="v-sidebar__icon v-sidebar__icon--support"><SupportIcon /></span>
              {!sidebarCollapsed && <span>Copilot</span>}
            </NavLink>
          </div>

          {isAdmin && (
            <div className="v-sidebar__section">
              {!sidebarCollapsed && <span className="v-sidebar__label">Admin</span>}
                  <NavLink to="/admin" className="v-sidebar__link" end>
                <span className="v-sidebar__icon"><AdminIcon /></span>
                {!sidebarCollapsed && <span>AI Governance</span>}
              </NavLink>
              <NavLink to="/admin/api-diagnostics" className="v-sidebar__link">
                <span className="v-sidebar__icon"><AdminIcon /></span>
                {!sidebarCollapsed && <span>Copilot</span>}
              </NavLink>
            </div>
          )}
        </nav>

        <div className="v-sidebar__footer">
          <div className="v-sidebar__user">
            <div className="v-avatar">{user?.fullName?.charAt(0) || 'U'}</div>
            {!sidebarCollapsed && (
              <div className="v-sidebar__user-info">
                <span className="v-sidebar__user-name">{user?.fullName}</span>
                <span className="v-sidebar__user-role">{user?.role}</span>
              </div>
            )}
          </div>
          <button className="v-sidebar__logout" onClick={handleLogout} title="Sign out">
            {sidebarCollapsed ? <LogoutIcon /> : 'Sign out'}
          </button>
        </div>
      </aside>

      {/* ─── Main content ─── */}
      <main className="v-main">
        {(apiUnavailable || hasNewVersion) && (
          <div className={`v-update-banner ${apiUnavailable ? 'is-warning' : 'is-info'}`} role="status">
            {apiUnavailable ? (
              <>
                <strong>Backend update bezig.</strong> Even geduld: de service herstart meestal tijdens een nieuwe deployment.
                Probeer over ongeveer 15 seconden te herladen. Deze melding verdwijnt automatisch zodra{' '}
                <code>/api/health</code> weer reageert.
              </>
            ) : (
              <>
                <strong>Nieuwe versie beschikbaar.</strong>{' '}
                <button type="button" className="v-update-banner__reload" onClick={handleReloadForUpdate}>
                  Herlaad nu
                </button>
              </>
            )}
          </div>
        )}
        <Outlet />
      </main>

      <div
        className="v-deploy-bar"
        title="Laatste Docker-build van backend en frontend (commit + tijd)"
        aria-live="polite"
      >
        <span className="v-deploy-bar__label">Deploy</span>
        <span className="v-deploy-bar__sep">·</span>
        {(apiBuild?.activeColor === 'blue' || apiBuild?.activeColor === 'green') && (
          <>
            <span
              className={`v-deploy-bar__slot ${
                apiBuild?.instanceColor &&
                apiBuild.instanceColor !== apiBuild.activeColor
                  ? 'v-deploy-bar__slot--mismatch'
                  : ''
              }`}
              title={
                apiBuild?.instanceColor
                  ? 'Edge stuurt verkeer naar deze kleur (.active_color). API = JVM die dit antwoord gaf.'
                  : 'Edge stuurt verkeer naar deze kleur (bestand .active_color op de server).'
              }
            >
              Blue/green: <strong>{apiBuild.activeColor}</strong>
              {apiBuild?.instanceColor ? (
                <>
                  {' '}
                  · API: <strong>{apiBuild.instanceColor}</strong>
                </>
              ) : null}
            </span>
            <span className="v-deploy-bar__sep">·</span>
          </>
        )}
        <span className="v-deploy-bar__api">
          API:{' '}
          <code>{apiBuild?.commit ?? '…'}</code>
          {' · '}
          {formatDeployTime(apiBuild?.time)}
        </span>
        <span className="v-deploy-bar__sep">·</span>
        <span className="v-deploy-bar__disk">
          <span className="v-deploy-bar__disk-icon" aria-hidden><DiskIcon /></span>
          Disk free: {formatBytes(apiBuild?.diskFreeBytes)}
          {Number.isFinite(Number(apiBuild?.diskTotalBytes))
            ? ` / ${formatBytes(apiBuild?.diskTotalBytes)}`
            : ''}
        </span>
        {uiCommit && uiCommit !== 'unknown' && (
          <>
            <span className="v-deploy-bar__sep">·</span>
            <span className="v-deploy-bar__ui">
              UI: <code>{uiCommit}</code>
              {uiTime && uiTime !== 'unknown' ? ` · ${formatDeployTime(uiTime)}` : ''}
            </span>
          </>
        )}
        {apiBuild?.deployAutomation?.lastAttemptStatus === 'success' && (
          <>
            <span className="v-deploy-bar__sep">·</span>
            <span
              className="v-deploy-bar__auto v-deploy-bar__auto--ok"
              title="Laatste voltooide automatische installer-run op deze server (bestand deploy_status.json op de EC2)."
            >
              Automatische deploy: geslaagd
              {apiBuild.deployAutomation.lastSuccessfulHeadShort || apiBuild.deployAutomation.lastAttemptHeadShort ? (
                <>
                  {' '}
                  · commit{' '}
                  <code>
                    {apiBuild.deployAutomation.lastSuccessfulHeadShort
                      ?? apiBuild.deployAutomation.lastAttemptHeadShort}
                  </code>
                </>
              ) : null}
              {apiBuild.deployAutomation.lastSuccessfulAtUtc || apiBuild.deployAutomation.lastAttemptAtUtc ? (
                <>
                  {' '}
                  ·{' '}
                  {formatDeployTime(
                    apiBuild.deployAutomation.lastSuccessfulAtUtc ?? apiBuild.deployAutomation.lastAttemptAtUtc,
                  )}
                </>
              ) : null}
            </span>
          </>
        )}
        {apiBuild?.deployAutomation?.lastAttemptStatus === 'failed' && (
          <>
            <span className="v-deploy-bar__sep">·</span>
            <span
              className="v-deploy-bar__auto v-deploy-bar__auto--fail"
              title="De server draait nog de vorige werkende stack; ventus-auto-update probeert de installatie opnieuw (zie ventus-auto-update.log)."
            >
              Automatische deploy: mislukt op commit{' '}
              <code>{apiBuild.deployAutomation.lastAttemptHeadShort ?? '—'}</code>
              {apiBuild.deployAutomation.lastAttemptExitCode != null
                ? ` · exit ${apiBuild.deployAutomation.lastAttemptExitCode}`
                : ''}
              {apiBuild.deployAutomation.lastAttemptAtUtc
                ? ` · ${formatDeployTime(apiBuild.deployAutomation.lastAttemptAtUtc)}`
                : ''}
              {' · wordt automatisch opnieuw geprobeerd'}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
